import React from 'react';
import { Dropdown, Image, Modal } from 'semantic-ui-react';
import { TimePicker } from 'material-ui-time-picker';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Constant from '../../common/Constant';
import { getProjectWithId } from '../../helpers/project';
import Strings from '../../common/Strings';
import { getTimerText } from '../../helpers/timer';
import { timerActions, uiActions, workLogActions } from '../../actions/index';
import { Dialog } from '../views/Dialog';
import Analytics from '../../analytics/Analytics';
import Events from '../../analytics/Events';
import './TimerDetails.css';
import '../Common.css';

const moment = require('moment');

class TimerDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      intervalId: '',
      discardModalOpen: false,
      notes: '',
      startTimestamp: moment().subtract(
        props.timer.millisRecorded,
        'milliseconds',
      ),
      endTimestamp: moment(),
      startingAtOpen: false,
      endingAtOpen: false,
    };
  }

  componentWillMount() {
    this.updateInterval(this.props);
  }

  componentWillReceiveProps(newProps) {
    this.updateInterval(newProps);

    if (this.props.timer.status !== newProps.timer.status) {
      const endTimestamp = moment();
      const startTimestamp = endTimestamp
        .clone()
        .subtract(newProps.timer.millisRecorded, 'milliseconds');
      this.setState({ startTimestamp, endTimestamp });
    }
  }

  componentWillUnmount() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  onPressStartTimer = project => {
    if (project) {
      const { status } = this.props.timer;
      if (status === Constant.TIMER_NOT_RUNNING) {
        this.props.dispatch(timerActions.startTimer(project, this.props.timer));
      } else if (status === Constant.TIMER_RUNNING) {
        this.props.dispatch(timerActions.stopTimer(project, this.props.timer));
      } else if (status === Constant.TIMER_PAUSED) {
        this.props.dispatch(timerActions.startTimer(project, this.props.timer));
      }
    }
  };

  onPressLogTime = project => {
    const { notes, startTimestamp, endTimestamp } = this.state;
    const millis = this.props.timer.millisRecorded;
    const workLog = {
      totalLoggedMillis: 0,
      notes,
      startTimestamp: startTimestamp.format(Constant.DATE_FORMAT_LONG),
      endTimestamp: endTimestamp.format(Constant.DATE_FORMAT_LONG),
    };

    this.props.dispatch(workLogActions.updateWorkLog(project, workLog, millis));
    this.props.dispatch(uiActions.timerProjectClicked(''));
    this.props.dispatch(timerActions.discardTimerLog(this.props.timer));
  };

  onNotesChange = e => {
    this.setState({ notes: e.target.value });
  };

  onPressDiscard = () => {
    this.setState({ discardModalOpen: true });
  };

  getButtonText() {
    const { status } = this.props.timer;
    if (status === Constant.TIMER_NOT_RUNNING) {
      return Strings.TIMER.startTimer;
    } else if (status === Constant.TIMER_RUNNING) {
      return Strings.TIMER.stopTimer;
    } else if (status === Constant.TIMER_PAUSED) {
      return Strings.TIMER.resumeTimer;
    }
    return '';
  }

  doDiscardLog = () => {
    Analytics.logEvent(Events.DISCARD_TIMER);
    this.setState({ discardModalOpen: false });
    this.props.dispatch(timerActions.discardTimerLog(this.props.timer));
  };

  updateInterval(props) {
    const { status } = props.timer;
    if (status === Constant.TIMER_RUNNING) {
      const interval = setInterval(() => {
        this.forceUpdate();
      }, 1000);
      if (this.state.intervalId) {
        clearInterval(this.state.intervalId);
      }
      this.setState({ intervalId: interval });
    } else if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  isLogButtonDisabled() {
    if (this.props.timer.status === Constant.TIMER_PAUSED) {
      return this.props.timer.millisRecorded / 1000 / 60 < 1;
    }
    return true;
  }

  getStartingAtText() {
    return moment(this.state.startTimestamp).format('h.mm A');
  }

  getEndingAtText() {
    return moment(this.state.endTimestamp).format('h.mm A');
  }

  renderLogButton(project) {
    const { notes } = this.state;
    const isVisible = this.props.timer.status === Constant.TIMER_PAUSED;
    const isDisabled = this.isLogButtonDisabled();
    const infoText = isDisabled
      ? Strings.TIMER.logInfoMin
      : Strings.TIMER.logInfoText;
    let TimesAndNotes = null;
    if (!isDisabled) {
      TimesAndNotes = (
        <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 30 }}>
          <div className="timer-time-container">
            <p className="timer-time-text">{Strings.ADD_TIME.startingAt}</p>
            {/* We use Dropdown here to achieve same visual than for actual Dropdowns */}
            <Dropdown
              text={this.getStartingAtText()}
              basic
              className="timer-drop-down"
              onClick={() => this.setState({ startingAtOpen: true })}
            >
              <Dropdown.Menu className="timer-drop-down-hidden" />
            </Dropdown>
          </div>
          <div style={{ height: 10 }} />
          <div className="timer-time-container">
            <p className="timer-time-text">{Strings.ADD_TIME.endingAt}</p>
            {/* We use Dropdown here to achieve same visual than for actual Dropdowns */}
            <Dropdown
              text={this.getEndingAtText()}
              basic
              className="timer-drop-down"
              onClick={() => this.setState({ endingAtOpen: true })}
            >
              <Dropdown.Menu className="timer-drop-down-hidden" />
            </Dropdown>
          </div>
          <textarea
            id="timer-log-notes-input"
            onChange={this.onNotesChange}
            placeholder={Strings.ADD_TIME.notesPlaceholder}
            value={notes}
          />
        </div>
      );
    }
    return (
      <div
        className="timer-details-log-container"
        style={{
          opacity: isVisible ? 1 : 0,
          flexGrow: 1,
          justifyContent: 'center',
        }}
      >
        {TimesAndNotes}
        <button
          disabled={isDisabled}
          id="timer-details-log-button"
          onClick={() => this.onPressLogTime(project)}
        >
          {Strings.TIMER.logRecordedTime}
        </button>
        <p id="timer-details-info">{infoText}</p>
      </div>
    );
  }

  renderDiscard() {
    const isVisible = this.props.timer.status === Constant.TIMER_PAUSED;
    return (
      <button
        disabled={!isVisible}
        id="timer-details-discard"
        onClick={this.onPressDiscard}
      >
        {Strings.TIMER.discardTime}
      </button>
    );
  }

  renderModals() {
    if (this.state.discardModalOpen) {
      return (
        <Dialog
          image="/emoji/bomb.svg"
          title={Strings.TIMER.discardModalTitle}
          body={Strings.TIMER.discardModalBody}
          buttonStyle="common-modal-negative-button"
          buttonText={Strings.TIMER.discardModalButton}
          buttonOnClick={this.doDiscardLog}
          onClose={() => this.setState({ discardModalOpen: false })}
        />
      );
    }

    return null;
  }

  changeStartingAt = time => {
    const millis = this.props.timer.millisRecorded;
    const startTimestamp = moment(time);
    const endTimestamp = startTimestamp.clone().add(millis, 'milliseconds');
    this.setState({ startTimestamp, endTimestamp });
  };

  changeEndingAt = time => {
    const millis = this.props.timer.millisRecorded;
    const endTimestamp = moment(time);
    const startTimestamp = endTimestamp
      .clone()
      .subtract(millis, 'milliseconds');
    this.setState({ startTimestamp, endTimestamp });
  };

  getStartingAtForModal() {
    return moment(this.state.startTimestamp).toDate();
  }

  getEndingAtForModal() {
    return moment(this.state.endTimestamp).toDate();
  }

  renderTimePickerModal() {
    return (
      <div>
        <Modal
          centered
          open={this.state.startingAtOpen}
          basic
          size="mini"
          onClose={() => this.setState({ startingAtOpen: false })}
        >
          <Modal.Content>
            <div>
              <TimePicker
                mode="12h"
                onChange={this.changeStartingAt}
                value={this.getStartingAtForModal()}
              />
              <button
                className="time-picker-modal-done"
                onClick={() => this.setState({ startingAtOpen: false })}
              >
                {Strings.COMMON.done.toUpperCase()}
              </button>
            </div>
          </Modal.Content>
        </Modal>
        <Modal
          centered
          open={this.state.endingAtOpen}
          basic
          size="mini"
          onClose={() => this.setState({ endingAtOpen: false })}
        >
          <Modal.Content>
            <div>
              <TimePicker
                mode="12h"
                onChange={this.changeEndingAt}
                value={this.getEndingAtForModal()}
              />
              <button
                className="time-picker-modal-done"
                onClick={() => this.setState({ endingAtOpen: false })}
              >
                {Strings.COMMON.done.toUpperCase()}
              </button>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    );
  }

  render() {
    const { timer, project } = this.props;
    let backgroundColor;
    let title;
    let startTimerDisabled;
    let freelancer;
    let timerText;

    if (timer.status === Constant.TIMER_NOT_RUNNING) {
      if (project) {
        backgroundColor = project.color;
        title = project.name;
        startTimerDisabled = false;
        freelancer = '/graphic/timer-running.png';
        timerText = getTimerText(timer);
      } else {
        backgroundColor = '';
        title = 'Title';
        startTimerDisabled = true;
        freelancer = '/graphic/timer-not-running.png';
        timerText = '0:00:00';
      }
    } else {
      const p = getProjectWithId(timer.projectId);
      backgroundColor = p.color;
      title = p.name;
      startTimerDisabled = false;
      if (timer.status === Constant.TIMER_RUNNING) {
        freelancer = '/graphic/timer-running.png';
      }
      timerText = getTimerText(timer);
    }

    return (
      <div className="timer-details-root" style={{ backgroundColor }}>
        <h1 id="timer-details-title-text" className="timer-details-title">
          {title}
        </h1>
        <p id="timer-details-timer-value">{timerText}</p>
        <button
          disabled={startTimerDisabled}
          id="timer-details-start-timer-button"
          onClick={() => this.onPressStartTimer(project)}
        >
          {this.getButtonText()}
        </button>
        {this.renderLogButton(project)}
        {freelancer && (
          <div className="timer-freelancer-container">
            <Image className="timer-freelancer" src={freelancer} />
          </div>
        )}
        <div className="timer-discard-bottom-wrap">
          {this.renderDiscard()}
          {this.renderModals()}
          {this.renderTimePickerModal()}
        </div>
      </div>
    );
  }
}

TimerDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }),
  timer: PropTypes.shape({
    status: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    startAtMillis: PropTypes.number.isRequired,
    millisRecorded: PropTypes.number.isRequired,
  }).isRequired,
};

TimerDetails.defaultProps = {
  project: undefined,
};

const mapStateToProps = state => ({
  timer: state.user.timer,
});

export default connect(mapStateToProps)(TimerDetails);



// WEBPACK FOOTER //
// ./src/components/timer/TimerDetails.js